import { useMemo } from "react";
import planeta1 from "../assets/planetas/planeta1.png";
import planeta2 from "../assets/planetas/planeta2.png";
import planeta3 from "../assets/planetas/planeta3.png";
import planetaTierra from "../assets/planetas/planeta_tierra.png";

export type PlanetaProps = {
  url: string;
  isDestroible: boolean;
};

/**
 *
 * @param cantColor
 * @description genera coleres random para las figuras existentes
 */
export const usePlanetasRandom = (cantPlanetas: number): PlanetaProps[] => {
  const planetas: PlanetaProps[] = [];
  for (let index = 0; index < cantPlanetas; index++) {
    const indexRandomImage = Math.floor(Math.random() * 4);
    if (indexRandomImage == 1) {
      planetas.push({ url: planeta1, isDestroible: true });
    } else if (indexRandomImage == 2) {
      planetas.push({ url: planeta2, isDestroible: true });
    } else if (indexRandomImage == 3) {
      planetas.push({ url: planeta3, isDestroible: true });
    } else {
      planetas.push({ url: planetaTierra, isDestroible: false });
    }
  }

  useMemo(
    () => ({
      ...planetas
    }),
    [cantPlanetas]
  );
  return planetas;
};
